import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDisableTaskOutline } from 'shared/services/local-storage';

import { queryKey } from './use-disable-task-outline-query';

export const useSetDisableTaskOutlineMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, boolean>({
    mutationFn: async (value) => {
      setDisableTaskOutline(value);
      await queryClient.invalidateQueries({ queryKey: [queryKey] });
    },
  });
};
